import React, { useState, useEffect, useContext } from 'react'
import { Steps, Divider } from 'antd'
import _ from 'lodash'
import FormComponent from './Form'
import { substeps } from '../assets/constants'
import { StepContext } from '../utils/StepContext'

const { Step } = Steps

const SubSteps = (props) => {
  const {
    subStep: stepValue,
    setSubStep: setStepValue,
    handleIncrementSubStep,
    handleDecrementSubStep,
    handleGoToNextStep,
    handleGoToStepFromRiepilogo,
    handleGoToRiepilogo
  } = useContext(StepContext)
  const [totalLength, setTotalLength] = useState(
    _(substeps)
      .map((item) => item.steps.length)
      .reduce((sum, length) => sum + length)
  )
  useEffect(() => {
    let step = 0
    _.times(
      props.stepValue,
      (index) => (step += _.size(_.get(substeps, `[${index}.steps]`)))
    )
    step += stepValue + 1
    props.setProgress((step / totalLength) * 100)
  }, [stepValue])
  useEffect(() => {
    setStepValue(props.draft.subStep)
  }, [props.draft.subStep])

  const [editing, setEditing] = useState(false)
  const stateIncrementStep = () => {
    setEditing(false)
    handleIncrementSubStep()
  }
  const decrementStep = () => {
    setEditing(false)
    handleDecrementSubStep()
  }

  if (stepValue === null) {
    return 'Caricamento ...'
  }

  const canIncrement = stepValue < substeps[props.stepValue].steps.length - 1
  const canDecrement = stepValue > 0
  const goToRiepilogo = handleGoToRiepilogo
  const goToStep = handleGoToStepFromRiepilogo
  const incrementStep = canIncrement
    ? () => stateIncrementStep()
    : handleGoToNextStep
  return (
    <>
      {process.env.REACT_APP_STEPPER_ENABLED === 'true' && (
        <>
          <div className='w-full overflow-auto'>
            <Steps
              current={stepValue}
              size='small'
              labelPlacement='vertical'
              type='default'
            >
              {_.map(substeps[props.stepValue].steps, (item, index) => (
                <Step
                  key={item.title}
                  title={item.title}
                  onClick={() => setStepValue(index)}
                />
              ))}
            </Steps>
          </div>
          <Divider />
        </>
      )}
      <div className='steps-content'>
        <FormComponent
          canDecrement={canDecrement}
          canIncrement={canIncrement}
          decrementStep={decrementStep}
          incrementStep={incrementStep}
          goToStep={goToStep}
          goToRiepilogo={goToRiepilogo}
          formName={props.formName}
          stepValue={stepValue}
          masterStepValue={props.stepValue}
          disabled
          editing={editing}
          setEditing={setEditing}
          draft={props.draft}
        >
          {_.get(
            substeps,
            `[${props.stepValue}].steps.[${stepValue}].content`,
            () => console.error('bohh')
          )}
        </FormComponent>
      </div>
    </>
  )
}

export default SubSteps
